const { formatDate } = require("../components/utils/date");
const { hasLanguageTag } = require("../components/utils/language");

const transformWordPressPost = (post) => ({
  slug: post.slug,
  title: post.title,
  excerpt: post.excerpt ? post.excerpt.replace(/<[^>]*>/g, '') : "",
  content: post.content,
  date: post.date,
  categories: Object.keys(post.categories || {}).map(name => ({ name })),
  tags: Object.keys(post.tags || {}).map(name => ({ 
    name,
    wordpress_id: post.tags[name].ID 
  })),
  imgSrc: post.featured_image || (post.featured_media ? post.featured_media.source_url : null),
});

const transformToGatsbyNode = (post) => ({
  slug: post.slug,
  title: post.title,
  date: post.date,
  excerpt: post.excerpt,
  content: post.content,
  tags: Object.keys(post.tags || {}).map(tagName => ({
    name: tagName,
    wordpress_id: post.tags[tagName].ID
  })),
  categories: Object.keys(post.categories || {}).map(catName => ({
    name: catName
  })),
  featured_media: {
    source_url: post.featured_image || (post.featured_media ? post.featured_media.source_url : '')
  }
});

const transformForUI = (posts, language, postType = 'updates') => {
  return posts
    .filter(post => hasLanguageTag(post, language))
    .map(post => {
      const hrefTag = post.tags && post.tags.find(tag => 
        tag && tag.startsWith && tag.startsWith("href:"));
      
      const href = hrefTag ? hrefTag.split(":").slice(1).join(":") : null;
      
      return {
        ...post,
        date: formatDate(post.date),
        category: post.categories && post.categories.length > 0 ? post.categories[0].name : "",
        to: href ? undefined : `/${language}/${postType}/${post.slug}/`,
        href: href || undefined
      };
    });
};

module.exports = {
  transformWordPressPost,
  transformToGatsbyNode,
  transformForUI
}; 